export const short = (value?: string | null, head = 5, tail = 4) =>
  value ? `${value.slice(0, head)}...${value.slice(-tail)}` : '—'

export const sol = (lamports?: number | null) => {
  if (lamports === null || lamports === undefined || Number.isNaN(Number(lamports))) return '—'
  return `${(Number(lamports) / 1_000_000_000).toLocaleString(undefined, { maximumFractionDigits: 4 })} SOL`
}

export const number = (value?: number | null) => Number(value || 0).toLocaleString()

export const date = (value?: string | number | null) => {
  if (!value) return '—'
  const parsed = typeof value === 'number' && value < 10_000_000_000 ? value * 1000 : value
  const d = new Date(parsed)
  return Number.isNaN(d.getTime()) ? String(value) : d.toLocaleString()
}


const INVALID_MEDIA_MARKERS = [
  'pending-public-asset-uri',
  'addurlto.here',
  'add-url-to.here',
  'add_url_here',
  'image_url_here',
]

const usableMediaUrl = (value: unknown) => {
  const text = String(value || '').trim()
  if (!text) return ''
  const lower = text.toLowerCase()
  if (INVALID_MEDIA_MARKERS.some(marker => lower.includes(marker))) return ''
  return text
}

/**
 * One image resolver for Rose NFT cards.  Helius DAS, the Rose registry and
 * marketplace provider payloads expose artwork in different fields; prefer
 * canonical/indexed image fields, then fall back to DAS image-shaped files.
 */
export const resolveAssetImage = (asset: any): string => {
  if (!asset) return ''
  const direct = [
    asset.image_url,
    asset.image,
    asset.thumbnail,
    asset.preview,
    asset.media?.image,
    asset.content?.links?.image,
    asset.content?.metadata?.image,
    asset.metadata?.image,
  ]
  for (const candidate of direct) {
    const url = usableMediaUrl(candidate)
    if (url) return url
  }

  const files = [
    ...(Array.isArray(asset.content?.files) ? asset.content.files : []),
    ...(Array.isArray(asset.files) ? asset.files : []),
  ]
  const imageFiles = files.filter((file:any) => {
    const mime = String(file?.mime || file?.mimeType || file?.type || '').toLowerCase()
    return mime.startsWith('image/') || mime === 'image'
  })
  for (const file of [...imageFiles, ...files]) {
    const url = usableMediaUrl(file?.cdn_uri || file?.cdnUri || file?.uri || file?.url)
    if (url) return url
  }
  return ''
}

export const isSolanaAddressLike = (value: string) => /^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(value.trim())

export const traitValue = (value: unknown) => {
  if (value === null || value === undefined) return '—'
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}
